const CORRELATION_ID_HEADER = 'x-correlation-id';
const CORRELATION_ID_STORAGE_KEY = 'gtp-correlation-id';
let correlationIdRoot = null;
export const addCorrelationIdMiddleware = (axios) => {
    axios.interceptors.request.use(async (request) => {
        const correlationId = getCorrelationId();
        if (correlationId) {
            request.headers[CORRELATION_ID_HEADER] = correlationId;
        }
        return request;
    });
    return axios;
};
export const resetCorrelationId = () => {
    window.localStorage.removeItem(CORRELATION_ID_STORAGE_KEY);
    correlationIdRoot = null;
};
//////////
/**
 * Generates a new correlation id based on a unique root for the browser.
 */
function getCorrelationId() {
    const root = getCorrelationIdRoot();
    if (!root)
        return undefined;
    const ext = generate(4);
    return `${root}-${ext}`;
}
/**
 * Gets the root of the correlation id. All correlation ids from the same browser will share this root.
 * The root is a two-letter prefix (to make it easier to visually parse/match) followed by 8 random characters.
 */
function getCorrelationIdRoot() {
    if (correlationIdRoot)
        return correlationIdRoot;
    correlationIdRoot = window.localStorage.getItem(CORRELATION_ID_STORAGE_KEY);
    if (!correlationIdRoot) {
        window.localStorage.setItem(CORRELATION_ID_STORAGE_KEY, (correlationIdRoot = `${generatePrefix()}-${generate(8)}`));
    }
    return correlationIdRoot;
}
/**
 * Generates the two character prefix for the correlation id root.
 */
function generatePrefix() {
    const randomChar = () => 97 + Math.floor(Math.random() * 26);
    return String.fromCharCode(randomChar(), randomChar());
}
/**
 * Gets random hex characters up to the specified length.
 */
function generate(length) {
    const generator = crypto ?? window.msCrypto;
    if (!generator?.randomUUID)
        return undefined;
    // The UUID is dash separated. Since we never ask for more than eight characters we can just use a substring and
    // be assured we won't get any separators.
    return generator.randomUUID().substring(0, length);
}
//# sourceMappingURL=index.js.map